// load pre polyfill
import './pre-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.less'; // before import App component
import App from './app';
import * as serviceWorker from './serviceWorker';
import 'moment/locale/zh-cn';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.register();
serviceWorker.unregister();
